import * as ActionTypes from '../constants/ActionTypes'

const initialState = {
    loading: false,
    loading_bus_stops_eta: false,
    loading_bus_routes_eta: false,
    loading_bus_route_stops: false,
    loading_shuttle_schedules: false,
    bus_route_stops: null,
    bus_stops: null,
    locations: null,
    destinations: null,
    shuttle_schedules: null,
    routes: null,
    total: 0,
    page: 1,
    limit: 10,
    count: 0,
    meta: {}
}

export default function transportPageReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_REQUEST:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_ERROR:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_SUCCESS:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_REQUEST:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_ERROR:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_SUCCESS:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_REQUEST:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_ERROR:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_SUCCESS:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_REQUEST:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_ERROR:
        case ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_SUCCESS:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_REQUEST:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_ERROR:
        case ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_SUCCESS:
        case ActionTypes.GET_TRANSPORT_LOCATIONS_REQUEST:
        case ActionTypes.GET_TRANSPORT_LOCATIONS_ERROR:
        case ActionTypes.GET_TRANSPORT_LOCATIONS_SUCCESS:
        case ActionTypes.GET_TRANSPORT_DESTINATIONS_REQUEST:
        case ActionTypes.GET_TRANSPORT_DESTINATIONS_ERROR:
        case ActionTypes.GET_TRANSPORT_DESTINATIONS_SUCCESS:
        case ActionTypes.GET_TRANSPORT_LOCATION_ETA_REQUEST:
        case ActionTypes.GET_TRANSPORT_LOCATION_ETA_ERROR:
        case ActionTypes.GET_TRANSPORT_LOCATION_ETA_SUCCESS:
        case ActionTypes.GET_SHUTTLE_SCHEDULES_REQUEST:
        case ActionTypes.GET_SHUTTLE_SCHEDULES_ERROR:
        case ActionTypes.GET_SHUTTLE_SCHEDULES_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        case ActionTypes.RESET_TRANSPORT_PAGE:
            return {
                ...initialState
            }
        case ActionTypes.RESET_TRANSPORT_META:
            return {
                ...state,
                meta: {}
            }
        default:
            return state
    }
}
